/**
 * Chunks an array into sub-arrays of specified size and pads incomplete chunks with null
 * @param arr - The array to chunk
 * @param numberOfColumns - Number of elements per chunk
 * @returns Array of arrays, each containing exactly numberOfColumns elements (padded with null if needed)
 */
export default function chunkArrayWithPadding<T>(
  arr: T[],
  numberOfColumns: number
): (T | null)[][] {
  return arr.reduce<(T | null)[][]>((acc, _, i) => {
    if (i % numberOfColumns === 0) {
      const chunk = arr.slice(i, i + numberOfColumns);
      const paddingLength = numberOfColumns - chunk.length;
      const paddedChunk: (T | null)[] = [
        ...chunk,
        ...Array.from({ length: paddingLength }, (): null => null),
      ];
      return [...acc, paddedChunk];
    }
    return acc;
  }, []);
}
